<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a routerLink="/page/dashboard"
        ><i class="icon text-info fa fa-home"></i
      ></a>
    </li>
    <li class="breadcrumb-item active" aria-current="page">
      {{ "Form.ListofC" | translate }}
    </li>
  </ol>
</nav>

<div class="row">
  <div class="col-md-12">
    <!-- Filter row -->
    <!-- <div
      class=""
      style="margin-bottom: 0 !important; background: transparent !important"
    >
      <table class="" style="background-color: transparent !important">
        <thead
          class=""
          style="
            background: transparent !important;
            background-color: transparent !important;
          "
        >
          <tr>
            <th style="width: 10%">
              <input
                type="text"
                [(ngModel)]="filter.transactionId"
                placeholder="Filter by Transaction Id"
                style="background-color: rgba(0, 0, 0, 0.03) !important"
                class="form-control m-1 mb-1 me-1 ms-0"
                (input)="applyFilter()"
              />
            </th>
            <th style="width: 10%">
              <input
                type="text"
                [(ngModel)]="filter.companyName"
                placeholder="Filter by Company Name"
                style="background-color: rgba(0, 0, 0, 0.03) !important"
                class="form-control mt-1"
                (input)="applyFilter()"
              />
            </th>
            <th style="width: 10%">
              <input
                type="text"
                [(ngModel)]="filter.moduleName"
                placeholder="Filter by Module Name"
                style="background-color: rgba(0, 0, 0, 0.03) !important"
                class="form-control m-1"
                (input)="applyFilter()"
              />
            </th>
            <th style="width: 10%">
              <input
                type="text"
                [(ngModel)]="filter.moduleDisplayName"
                style="background-color: rgba(0, 0, 0, 0.03) !important"
                placeholder="Filter by Module Display Name"
                class="form-control m-1"
                (input)="applyFilter()"
              />
            </th>
            <th style="width: 10%">
              <input
                type="date"
                [(ngModel)]="filter.purchaseDate"
                placeholder="Filter by Purchase Date"
                style="background-color: rgba(0, 0, 0, 0.03) !important"
                class="form-control m-1"
                (input)="applyFilter()"
              />
            </th>
            <th style="width: 10%">
              <input
                type="date"
                [(ngModel)]="filter.validFrom"
                placeholder="Filter by Valid From"
                style="background-color: rgba(0, 0, 0, 0.03) !important"
                class="form-control m-1"
                (input)="applyFilter()"
              />
            </th>
            <th style="width: 10%">
              <input
                type="date"
                [(ngModel)]="filter.validUpto"
                placeholder="Filter by Valid Upto"
                style="background-color: rgba(0, 0, 0, 0.03) !important"
                class="form-control m-1"
                (input)="applyFilter()"
              />
            </th>
            <th style="width: 10%"></th>
          </tr>
        </thead>
      </table>
    </div> -->

    <div *ngIf="isLoading; else notLoading" class="loaderdata">
      <div class="spinner-border" role="status">
        <span class="sr-only">{{ "Form.Loading" | translate }}</span>
      </div>
    </div>
    <ng-template #notLoading>
      <div class="main-card mb-3 card">
        <table
          class="align-middle mb-0 table table-borderless table-striped table-hover"
        >
          <thead class="font-size-lg text-white">
            <tr>
              <th style="width: 10%">
                <div class="d-flex justify-content-between align-items-center">
                  No.
                  <!--  <i
                    (click)="changeSort('transactionId')"
                    style="cursor: pointer"
                    class="fa fa-sort"
                  ></i> -->
                </div>
              </th>
              <th style="width: 20%">
                <div class="d-flex justify-content-between align-items-center">
                  {{ "Form.Placeholder.NAME" | translate }}
                  <i
                    (click)="changeSort('name')"
                    style="cursor: pointer"
                    class="fa fa-sort"
                  ></i>
                </div>
              </th>
              <th style="width: 20%">
                <div class="d-flex justify-content-between align-items-center">
                  <!-- {{ "Form.moduleName" | translate }} -->
                  Email
                  <i
                    (click)="changeSort('emailId')"
                    style="cursor: pointer"
                    class="fa fa-sort"
                  ></i>
                </div>
              </th>
              <th style="width: 20%">
                <div class="d-flex justify-content-between align-items-center">
                  <!-- {{ "Form.moduleDisplayName" | translate }} -->
                  Contact person
                  <i
                    (click)="changeSort('contactPerson')"
                    style="cursor: pointer"
                    class="fa fa-sort"
                  ></i>
                </div>
              </th>
              <th style="width: 10%">
                <div class="d-flex justify-content-between align-items-center">
                  <!-- {{ "Form.purchaseDate" | translate }} -->
                  Phone
                </div>
              </th>
              <th style="width: 10%">
                <div class="d-flex justify-content-between align-items-center">
                  <!-- {{ "Form.purchaseDate" | translate }} -->
                  Status
                  <i
                    (click)="changeSort('status')"
                    style="cursor: pointer"
                    class="fa fa-sort"
                  ></i>
                </div>
              </th>
              <th class="text-center" style="width: 10%">
                {{ "Form.ACTIONS" | translate }}
              </th>
            </tr>
          </thead>
          <tbody *ngIf="sortedData?.length; else noData">
            <tr *ngFor="let item of sortedData; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.emailId }}</td>
              <td>{{ item.contactPerson }}</td>
              <td>{{ item.phone != null ? item.phone : "-" }}</td>
              <td>{{ item.status }}</td>

              <td class="text-center">
                <span
                  mat-icon-button
                  style="cursor: pointer"
                  [matMenuTriggerFor]="menu"
                  class="actions-icon-btn pt-3 pb-1 px-2 bg-transparent"
                >
                  <mat-icon>more_vert</mat-icon>
                </span>

                <mat-menu #menu="matMenu" class="text-center">
                  <button
                    mat-menu-item
                    (click)="disableCompany(item.id, item.status)"
                  >
                    <span
                      class="bg-transparent"
                      ngbTooltip="Enable/Disable"
                      placement="top"
                      [container]="'body'"
                    >
                      {{ item.status === "Enabled" ? "Disable" : "Enable" }}
                      <!-- <i
                        class="fa fa-trash-o text-danger font-size-lg"
                        aria-hidden="true"
                      ></i> -->
                    </span>
                  </button>
                  <button mat-menu-item (click)="resendInvitation(item)">
                    <span
                      class="bg-transparent"
                      ngbTooltip="Resend invite"
                      placement="top"
                      [container]="'body'"
                    >
                      Resend invite
                    </span>
                  </button>
                </mat-menu>
              </td>
              <!-- <td>{{ item.validFrom | date : "dd MMM yyyy" }}</td> -->
              <!--  <td>
                {{ item.validUpto | date : "dd MMM yyyy" }}
                <p style="color: grey">
                  ({{ item.validUpto | remainingDays }})
                </p>
              </td>
              <td>
                <div *ngIf="item.transactionId; else noTransactionId">
                  <a
                    style="color: blue"
                    routerLink="/page/transaction-detail/{{
                      item.transactionId
                    }}"
                    >{{ "Form.Placeholder.Viewtransactiondetails" | translate }}
                  </a>
                </div>
                <ng-template #noTransactionId>-</ng-template>
              </td> -->
            </tr>
          </tbody>
          <ng-template #noData>
            <tbody>
              <tr>
                <td colspan="7" class="text-center">
                  {{ "Form.NoDataAvailable" | translate }}
                </td>
              </tr>
            </tbody>
          </ng-template>
        </table>
      </div>
    </ng-template>
  </div>
</div>

<ng-template #deactiveCompany let-modal let-close="c" let-dismiss="d">
  <div class="modal-header">
    <div class="modal-title">
      <h4>{{ displayStatus }}</h4>
      <button
        type="button"
        class="close mt-2 pt-2"
        aria-label="Close"
        (click)="c('cancel')"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    Are you sure you want to {{ displayStatus }} this company?
  </div>
  <div class="modal-footer">
    <button class="btn btn-primary" (click)="c('save')">Save</button>
    <button class="btn" (click)="c('cancel')">Cancel</button>
  </div>
</ng-template>
